import { FC, useEffect, useRef } from 'react'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import {
  CookieCategory,
  useOneTrustConsentCategory,
} from '@moonpig/web-core-browser-storage'
import { Router } from 'next/router'
import { initMixpanel, trackPageView } from './mixpanelClient'

export const MixpanelSetup: FC<{ url: string }> = ({ url }) => {
  const isInitialised = useRef(false)

  const mixpanelRecordingPercent = useExperiment('mixpanel-recording-percent', {
    fallback: 0,
  })

  const mixpanelEnabled = useExperiment('mixpanel-enabled', {
    fallback: false,
  })

  const isWorkPage = url && url.match(/^\/[a-z]{2,2}\/(business|work)/)

  const userHasConsented = useOneTrustConsentCategory(
    CookieCategory.PERFORMANCE,
  )

  // Initialize Mixpanel when consent given, enabled, and on work page
  useEffect(() => {
    if (isInitialised.current) return

    if (userHasConsented && isWorkPage && mixpanelEnabled) {
      isInitialised.current = true
      initMixpanel(mixpanelRecordingPercent)
      trackPageView(url)
    }
  }, [
    url,
    userHasConsented,
    isWorkPage,
    mixpanelEnabled,
    mixpanelRecordingPercent,
  ])

  // Set up route change listener when consent given and Mixpanel enabled
  useEffect(() => {
    if (!userHasConsented || !mixpanelEnabled) return

    const handleRouteChange = (newUrl: string) => {
      if (isInitialised.current) {
        trackPageView(newUrl)
      }
    }

    Router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [userHasConsented, mixpanelEnabled])

  return null
}
